import styled from 'styled-components';

export const MODAL_TITLE_ID = 'modal-title';

export type ModalSize = 'sm' | 'md';

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  text-align: left;
  padding-bottom: 1.5rem;
`;

const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

const Title = styled.h2`
  font-size: 20px;
  margin: 0;
  color: var(--text);
  font-weight: 550;
`;

const Description = styled.p`
  margin: 0;
  color: var(--text-muted);
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  color: var(--text-muted);
  gap: 0.75rem;

  & > p {
    margin: 0;
  }
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
`;

type ModalLayoutProps = {
  title: string;
  size?: ModalSize;
  description?: React.ReactNode;
  children?: React.ReactNode;
  footer?: React.ReactNode;
};

export const ModalLayout = ({
  title,
  size = 'md',
  description,
  children,
  footer,
}: ModalLayoutProps) => (
  <Layout data-modal-size={size}>
    <TitleBlock>
      <Title id={MODAL_TITLE_ID}>{title}</Title>
      {description && <Description>{description}</Description>}
    </TitleBlock>
    {children && <Body>{children}</Body>}
    {footer && <Footer>{footer}</Footer>}
  </Layout>
);
